import React, { useState, useContext, useEffect } from "react";
import TenantContext from "../../../utils/tenantContext";
import { Trans, useTranslation } from "react-i18next";

const Footer = () => {
  let date = new Date();
  const {tenant} = useContext(TenantContext);
  const [privacyPolicyUrl, privacyPolicyUrlSET] = useState("");
  const [termsAndConditionsUrl, termsAndConditionsUrlSET] = useState("");
  const { t } = useTranslation();
  
  useEffect(() => {
		if(tenant) {
			privacyPolicyUrlSET(tenant.privacy_policy_url);
      termsAndConditionsUrlSET(tenant.terms_and_conditions_url);
		}
	}, [tenant]);

  return (
    <footer className="footer text-left">
      <strong>
        <Trans i18nKey="general.footer.label.copyright" values={{ year: date.getFullYear() }}>
          Copyright © {date.getFullYear()}
        </Trans>&nbsp;
        <a
          href="https://www.music-link.io"
          target="_blank"
          rel="noopener noreferrer"
        >
          Music Link&nbsp;
        </a>
      </strong>
      <span>{t("general.footer.label.allRightsReserved")}</span> |
      <a style={{padding: '0 0 0 4px'}} href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer">{t("general.footer.label.privacyPolicy")}</a> |
      <a style={{padding: '0 0 0 4px'}} href={termsAndConditionsUrl} target="_blank" rel="noopener noreferrer">{t("general.footer.label.termsAndConditions")}</a>
    </footer>
  );
};

export default Footer;
